export default {
  mainContainer: {
    padding: ['40px 20px 0 20px', '', '72px 0 0 0'],
    margin: '0 auto',
    maxWidth: ['100%', '910px'],
    display: ['inherit', 'flex'],
    justifyContent: ['', 'space-evenly'],
    flexWrap: ['', 'wrap'],
  },
  sectionTitle: {
    fontSize: ['24px', '40px', '60px'],
    textTransform: 'uppercase',
    fontFamily: 'spoqaBold',
    marginBottom: ['20px', '0px'],
    width: ['', '100%'],
    color: '#28313A',
  },
  isFivePrizes: {
    gridTemplateColumns: ['100px 1fr', '266px'],
  },
  isSixPrizes: {
    gridTemplateColumns: ['100px 1fr', '266px'],
  },

  itemsCard: {
    padding: ['0 0 0 0', '81px 0 0 0'],
    color: '#28313A',
    display: ['grid'],
    gridTemplateColumns: ['100px 1fr', '220px', '227px'],
    gridTemplateRows: ['repeat(2, 1fr)', '167px auto auto', '204px 96px 60px'],
    gridColumnGap: ['29px', '20px', '60px'],
    gridRowGap: '0px',
    alignItems: 'center',
    fontSize: '16px',
    position: 'relative',
    textAlign: ['', 'center'],
    marginBottom: ['16px', '', ''],

    img: {
      maxWidth: ['116px', '167px', '196px'],
      gridArea: ['1 / 1 / 3 / 2', '1 / 1 / 2 / 2'],
      position: 'relative',
      borderRadius: '100%',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.09)',
      padding: ['11px', '16px', '19px'],
      zIndex: '0',
      margin: '0 auto',
    },

    h3: {
      fontFamily: 'bold',
      fontSize: ['16px', '16px', '25px'],
      display: 'block',
      width: '100%',
      gridArea: ['1 / 2 / 2 / 3', '2 / 1 / 3 / 2'],
      marginTop: ['0px', '26px', '32px'],
      alignSelf: ['end', 'start', 'start'],
    },
    p: {
      gridArea: ['2 / 2 / 3 / 3', '3 / 1 / 4 / 2'],
      fontFamily: 'heading',
      alignSelf: ['center', 'start', 'start'],
      fontSize: ['16px', '16px', '25px'],
    },
  },

  singleItemCard: {
    padding: '0',
    gridTemplateColumns: ['119px 1fr', '175px 1fr', '245px 1fr'],
    gridTemplateRows: ['', 'repeat(2, 1fr)'],
    gridColumnGap: '13px',
    gridRowGap: '0px',
    zIndex: '0',
    boxShadow: '0 15px 22px rgba(0, 0, 0, 0.08)',
    borderRadius: '8px',
    textAlign: ['', 'left'],
    height: ['135px', '223px', '296px'],
    margin: ['24px 0 16px 0', '81px 40px 0 40px'],

    img: {
      margin: ['0px', '0px'],
      maxWidth: ['119px', '197px', '245px'],
      maxHeight: ['119px', '197px', '245px'],
      gridArea: ['1 / 1 / 3 / 2', '1 / 1 / 3 / 2'],
      boxShadow: 'none',
    },
    h3: {
      gridArea: ['1 / 2 / 2 / 3', '1 / 2 / 2 / 3'],
      fontFamily: 'bold',
      fontSize: ['inherit', '25px'],
      display: 'block',
      width: '100%',
      maxWidth: '412px',
      alignSelf: ['center', 'end'],
    },
    p: {
      gridArea: ['2 / 2 / 3 / 3', '2 / 2 / 3 / 3'],
      fontFamily: 'heading',
      fontSize: ['inherit', '25px'],
      alignSelf: 'start',
    },
  },

  singleImageCard: {
    objectFit: 'cover',
    width: ['100%', '516px', '910px'],
    height: ['100%', '338px', '656px'],
    borderRadius: '8px',
    margin: ['0 0 0 0', '35px 0 0 0', '81px 0 0 0'],
  },

  singleSmallImageCard: {
    objectFit: 'cover',
    width: ['313px', '519px', '720px'],
    height: ['135px', '224px', '298px'],
    borderRadius: '8px',
    margin: ['0 0 0 0', '35px 0 0 0', '81px 0 0 0'],
  },

  badgeIcon: (singleFullWidthItem) => ({
    gridArea: !singleFullWidthItem
      ? ['1 / 1 / 3 / 2', '1 / 1 / 2 / 2']
      : ['1 / 1 / 3 / 2', '1 / 1 / 3 / 2'],
    zIndex: '1',
    alignSelf: 'start',
    position: 'relative',
    marginLeft: !singleFullWidthItem ? ['0px', '10px'] : ['0px'],
    left: singleFullWidthItem ? ['2px', '', '-43px'] : '0px',
    top: singleFullWidthItem ? ['-15px', '', '-45px'] : '0px',

    span: {
      clipPath:
        'polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)',
      fontSize: !singleFullWidthItem
        ? ['13px', '20px', '20px']
        : ['13px', '20px', '35px'],
      backgroundColor: '#D31145',
      width: !singleFullWidthItem ? ['33px', '50px'] : ['33px', '49px', '89px'],
      height: !singleFullWidthItem
        ? ['29px', '48px']
        : ['30px', '49px', '89px'],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'tmWhite',
      fontFamily: 'bold',
    },
  }),
}
